import React, { useState } from 'react';
import './blog.css';

const Categories = ({ setCategory }) => {
  const categories = ['All', 'Legal Advice', 'Case Studies', 'Industry Updates'];
  const [selectedCategory, setSelectedCategory] = useState('All');

  const handleCategoryClick = (cat) => {
    setSelectedCategory(cat);
    setCategory(cat);
  };

  return (
    <div className="categories-container">
      <div className="categories">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`category-button ${selectedCategory === cat ? 'selected' : ''}`}
            onClick={() => handleCategoryClick(cat)}
          >
            {cat}
          </button>
        ))}
      </div>
      <hr className="category-hr" />
    </div>
  );
};

export default Categories;
